import {
  GET_CAMPAIGN,
  GET_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_FAIL,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  DELETE_CAMPAIGN_FAIL,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN_FAIL,
  ADD_NEW_CAMPAIGN,
  ADD_CAMPAIGN_SUCCESS,
  ADD_CAMPAIGN_FAIL,
  CAMPAIGN_LOADING,
  CAMPAIGN_RESET,
} from "./actionType";

export const resetCampaignState = (actionType) => ({
  type: CAMPAIGN_RESET,
  payload: { actionType },
});

export const getCampaignSuccess = (actionType, data) => ({
  type: GET_CAMPAIGN_SUCCESS,
  payload: { actionType, data },
});

export const getCampaignFail = (actionType, error) => ({
  type: GET_CAMPAIGN_FAIL,
  payload: { actionType, error },
});

export const getCampaign = data => ({
  type: GET_CAMPAIGN,
  payload: data,
});

export const getCampaignLoading = () => ({
  type: CAMPAIGN_LOADING
});

export const deleteCampaign = data => ({
  type: DELETE_CAMPAIGN,
  payload: data,
});

export const deleteCampaignSuccess = data => ({
  type: DELETE_CAMPAIGN_SUCCESS,
  payload: data,
});

export const deleteCampaignFail = error => ({
  type: DELETE_CAMPAIGN_FAIL,
  payload: error,
});

export const updateCampaign = data => ({
  type: UPDATE_CAMPAIGN,
  payload: data,
});

export const updateCampaignFail = error => ({
  type: UPDATE_CAMPAIGN_FAIL,
  payload: error,
});

export const updateCampaignSuccess = data => ({
  type: UPDATE_CAMPAIGN_SUCCESS,
  payload: data,
});

export const addNewCampaign = data => ({
  type: ADD_NEW_CAMPAIGN,
  payload: data,
});

export const addCampaignSuccess = data => ({
  type: ADD_CAMPAIGN_SUCCESS,
  payload: data,
});

export const addCampaignFail = error => ({
  type: ADD_CAMPAIGN_FAIL,
  payload: error,
});